import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio3.jpg'
import IMG2 from '../../assets/port2.jpg'
import IMG3 from '../../assets/port3.jpg'
const Portfolio = () => {
  return (
    <section id= 'portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG1} alt=""/>
            </div>
            <h3>Weather Application </h3>
            <div className="portfolio__item-cta">
            <a href="https://github.com/DXD434/WeatherApp" className='btn' target='_blank'>Github</a>
            <a href="https://dxd434.github.io/WeatherApp/" classNmame='btn btn-primary' target='_blank'>Live Demo</a>
            </div>
        </article>
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG2} alt=""/>
            </div>
            <h3>Interactive SVG World Map </h3>
            <div className="portfolio__item-cta">
            <a href="https://github.com/DXD434/d280-javascript-programming" className='btn' target='_blank'>Github</a>
            <a href="https://dxd434.github.io/d280-javascript-programming/map" classNmame='btn' target='_blank'>Live Demo</a>
            </div>
          
        </article>
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG3} alt=""/>
            </div>
            <h3>Hotel Scheduling Application</h3>
            <div className="portfolio__item-cta">
            <a href="https://github.com/DXD434/d387-advanced-java" className='btn' target='_blank'>Github</a>
            
            </div>
          
        </article>
      </div>
    </section>
  )
}

export default Portfolio